<template>
  <div>
    <v-navigation-drawer v-model="drawer" height="100%" temporary app>
      <Sidebar />
    </v-navigation-drawer>
    <v-app-bar app>
    <v-toolbar-title class="font-weight-light align-self-center d-flex">
      <v-btn icon @click.stop="switchDrawer()">
        <v-icon>mdi-view-list</v-icon>
      </v-btn>
    </v-toolbar-title>
    <v-spacer />
    <span v-if="stg">{{ stg }}</span>
    <v-spacer />
    <v-toolbar-items>
      <v-row align="center" class="mx-0">
        <v-menu
          v-model="menu"
          offset-y
          transition="scale-transition"
        >
          <template v-slot:activator="{ on }">
            <v-chip
              pill
              v-on="on"
            >
              <v-avatar left>
                <v-icon>mdi-account-circle</v-icon>
              </v-avatar>
              <span v-if="user"
                >Welcome,
                {{
                  user.firstName
                    ? user.firstName + " " + user.lastName
                    : user.email
                }}</span
              >
            </v-chip>
            <v-btn icon @click.stop="logout">
              <v-icon>mdi-logout</v-icon>
            </v-btn>
          </template>
          <v-card width="300" class="pa-2">
            <v-list>
              <v-list-item v-if="user.firstName">
                <v-icon class="mr-2">mdi-email</v-icon>
                <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item v-if="user.phone">
                <v-icon class="mr-2">mdi-phone</v-icon>
                <v-list-item-subtitle>{{ user.phone }}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item v-if="user.groupName">
                <v-icon class="mr-2">mdi-account-group</v-icon>
                <v-list-item-subtitle>{{ getGroupName }}</v-list-item-subtitle>
              </v-list-item>
              <v-list-item v-if="!user.sftp && userRole === 'Customer'" @click="createSftpUser">
                <v-icon color="primary" class="mr-2" title="click to create sft user">mdi-folder-account</v-icon>
                <v-list-item-subtitle>create sftp user</v-list-item-subtitle>
              </v-list-item>
              <v-list-item v-if="user.sftp && userRole === 'Customer'">
                <v-icon class="mr-2" color="green" title="create sftp user">mdi-folder-account</v-icon>
                <v-list-item-subtitle>sftp already enabled</v-list-item-subtitle>
                <delete-with-confirm :id="user.email" :kind="'sftp'" @deleted="deleteSftpUser()" />
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-row>
    </v-toolbar-items>
  </v-app-bar>
  </div>
</template>
<script>
import { Auth } from "aws-amplify";
import { mapState } from "vuex";
import router from "@/router/index";
import { STAGE } from "@/constants";
import Sidebar from "@/components/layout/Sidebar";
import DeleteWithConfirm from "@/components/DeleteWithConfirm.vue";

export default {
  data: () => ({
    drawer: false,
    menu: false,
  }),
  components: {
    Sidebar,
    DeleteWithConfirm
  },
  computed: {
    stg: () => {
      switch (STAGE) {
        case "local":
          return "LOCAL";
        case "dev":
          return "DEVELOPMENT";
        case "cons":
          return "CONSOLIDATION";
        default:
          return null;
      }
    },
    getGroupName: (component) => {
      let tmp = component.user.groupName.split('@');
      let group = tmp[tmp.length-1];
      return group;
    },
    ...mapState({
      user: (state) => state.user,
      userRole: (state) => state.userRole,
    })
  },
  methods: {
    async logout() {
      try {
        await Auth.signOut();
        router.push("/");
      } catch (error) {
        this.$store.dispatch("dispatchError", {
          text: error.substr(0, 50) + " ...",
          type: "danger",
          cnsl: error,
        });
        router.push("/");
      }
    },
    switchDrawer() {
      this.drawer = !this.drawer;
    },
    async createSftpUser() {
      await this.$store.dispatch("putSftpCustomerAction", this.user);
      this.menu = false;
    },
    async deleteSftpUser() {
      await this.$store.dispatch("deleteSftpCustomerAction", this.user);
      this.menu = false;
    }
  }
}
</script>